import React, { Component } from "react";
import { FormGroup, ToggleButtonGroup, ToggleButton } from "react-bootstrap";
import styles from "./DurationRadio.scss";
import classNames from "classnames";

class DurationRadio extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: props.input.value || null
    };
    this.handleOnChange = this.handleOnChange.bind(this);
  }

  handleOnChange(value) {
    this.setState({ selected: value }, this.props.input.onChange(value));
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.input.value !== this.props.input.value) {
      const value = nextProps.input.value;
      this.setState({ selected: value }, this.props.input.onChange(value));
    }
  }

  render() {
    const { input, options } = this.props;

    return (
      <FormGroup>
        <ToggleButtonGroup
          type="radio"
          name={input.name}
          defaultValue={input.value}
          className={styles.buttonGroup}
          vertical={true}
          onChange={this.handleOnChange}
        >
          {options &&
            options.map((item, index) => {
              return (
                <ToggleButton
                  value={item.id}
                  name={input.name}
                  className={classNames({
                    [styles.radio]: true,
                    [styles.active]: this.state.selected == item.id
                  })}
                  key={index}
                  checked={true}
                >
                  <div className={styles.radioContainer}>
                    <div className={styles.circle} />
                    <div className={styles.text}>{item.value}</div>
                  </div>
                </ToggleButton>
              );
            })}
        </ToggleButtonGroup>
      </FormGroup>
    );
  }
}

export default DurationRadio;



// WEBPACK FOOTER //
// ./src/routes/employer/project/components/DurationRadio.js